
<ng-container *ngIf="variantClass === 'lottie--primary-banner'">
  <lottie-player
    src="/assets/animations/animation1.json"
    class="lottie"
    [ngClass]="variantClass"
    background="transparent"
    speed="1"
    autoplay
  />
</ng-container>

<ng-container *ngIf="variantClass === 'lottie--secondary-banner'">
  <lottie-player
    src="/assets/animations/animation2.json"
    class="lottie"
    [ngClass]="variantClass"
    background="transparent"
    speed="1"
    autoplay
  />
</ng-container>

<ng-container *ngIf="variantClass === 'lottie--third-banner'">
  <lottie-player
    src="/assets/animations/animation3.json"
    class="lottie"
    [ngClass]="variantClass"
    background="transparent"
    speed="1"
    autoplay
  />
</ng-container>

